module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true
      }
    }],
    staticClass: "top_content",
    attrs: {
      "element-loading-text": "拼命加载中"
    }
  }, [_c('sidebar', {
    attrs: {
      "shop": _vm.shop
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main",
    style: (_vm.origin == 'yirui' ? 'padding-left: 0' : 'padding-left: 220px')
  }, [_c('div', {
    staticClass: "header"
  }, [_c('ul', {
    staticClass: "nav-yirui",
    style: (_vm.origin == 'yirui' ? 'visibility:visible' : 'visibility:hidden')
  }, [_c('li', {
    staticClass: "nav-yirui-item"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.router('main/memberctl')
    }
  }, [_vm._v("\n            会员管理\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-yirui-item"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.router('main/memberredpoint')
    }
  }, [_vm._v("\n            会员集点\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-yirui-item"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.router('main/memberredpacket')
    }
  }, [_vm._v("\n            会员红包\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-yirui-item"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.router('main/memberstorage')
    }
  }, [_vm._v("\n            会员储值\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "user_wrapper",
    style: (_vm.origin == 'yirui' ? 'display:none' : 'display:-webkit-flex')
  }, [_c('div', {
    staticClass: "user_name"
  }, [_vm._v("\n          " + _vm._s(_vm.role.isCashier ? ("Welcome," + ((_vm.shop.opinfo || {}).opname) + "(" + ((_vm.shop.opinfo || {}).opuid) + ")") : 'Welcome') + "\n        ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(0)])])]), _vm._v(" "), _c('router-view', {
    attrs: {
      "shop": _vm.shop
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user_operation"
  }, [_c('i', {
    staticClass: "icon-ic_logout"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("退出")])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4b8471f5"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/main/main.vue
// module id = 825
// module chunks = 0